import React, { useState,useEffect } from "react";
import { API_URL,RESPONSE_SUCCESS,REQUEST_NOT_FOUND } from './../../GlobalConstents.js';
import { useNavigate,useParams } from "react-router-dom";
import HeaderLayout from "./../../Layout/Header";
import API from './../../Api';
import { toast } from 'react-toastify';
import Loader from "../../Elements/Loader";
import { ROUTE_EXAM_PAGE,RouteChanged } from '../../RouteConstents';

const ExamStartPage = () => {

    const navigate = useNavigate();

    const [records, setRecords] = useState([]); 
    const [isLoading, setIsLoading] = useState(false);
    const [examTitle, setExamTitle] = useState('');
    const { string } = useParams();

    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');

        getExamInfo(string)
        
    },[true]); 

    const getExamInfo = async (string) => {

        let objValue =  {"method_name":"runningExam","exam_id":string,"exam_view":0}

        setIsLoading(true);
        await API.post(API_URL,objValue).then(function (response) {
            setIsLoading(false);
            if (response.status === RESPONSE_SUCCESS) {
                if (response.data.status == "success") {
                    setExamTitle(response.data.examInfo.test_series_title);
                    
                } else {
                    toast.error(response.data.message);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
        });

    }

    const examBeginNow = async () => {
        let newURL = RouteChanged(ROUTE_EXAM_PAGE,string)
        navigate(newURL);
    } 

    

    return (
        <>
        <HeaderLayout />
        
        <section className="content">
            <div className="container-fluid">
                <div className="block-header">
                    <h2>Exam Rules</h2>
                </div>

                <div className="row clearfix">

                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div className="card">
                            <div className="header bg-cyan">
                                <h2>{examTitle}</h2>
                            </div>
                            <div className="body">
                                <p>
                                Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. 
                                </p>
                                
                                <p>
                                Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
                                </p>
                            </div>
                            <div className="btn btn-block btn-lg btn-success">
                                <button type="button" className="btn btn-default waves-effect" onClick={examBeginNow}>Exam Begin Now</button>
                            </div>
                        </div>
                    </div> 

                     
                </div>
            </div>
        </section>
        </>
    );
   
}
    
export default ExamStartPage;